import { useState } from 'react';
import { CalendarSearch, Mail } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger, InfoModal } from '../../components/ui/index.ts';
import { EmailPromptEditor } from '../dashboard/emails/Emails.tsx';
import { EmailDashboard } from '../dashboard/emails/EmailTables.tsx';
import { emailInfoContent } from '../dashboard/emails/components/infoModal.tsx';

export default function EmailsPage() {
  const [activeTab, setActiveTab] = useState<'history' | 'settings'>('history');

  return (
    <div className="space-y-6 p-4 md:p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-foreground flex items-center gap-2">
            <Mail className="h-8 w-8" />
            Email Management
          </h1>
          <p className="text-muted-foreground">
            Manage AI-generated follow-up emails from your phone conversations
          </p>
        </div>
        <div className="flex items-center gap-2">
          <InfoModal
            title="Email System Guide"
            description={emailInfoContent}
            triggerClassName="h-8 w-8"
          />
        </div>
      </div>
      {/* Main Content */}
      <Tabs value={activeTab} onValueChange={(value: string) => setActiveTab(value as 'history' | 'settings')}>
        <TabsList className="grid w-full grid-cols-2 max-w-[1400px]">
          <TabsTrigger value="history" className="flex items-center gap-2">
            <CalendarSearch className="size-4" />
            History
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Mail className="size-4" />
            Emails
          </TabsTrigger>
        </TabsList>

        <TabsContent value="history" className="space-y-6 max-w-[1400px]">
          <EmailDashboard />
        </TabsContent>

        <TabsContent value="settings" className="space-y-6 max-w-[1400px]">
          <EmailPromptEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
} 